module.exports = __webpack_public_path__ + "img/banner_RSV_bg.a09434e1.webp";